import { useSpring } from 'react-spring';

// TODO: Add a proper type fix for below code snippet
export function useFade(active: boolean) {
  return useSpring({ opacity: active ? 1 : 0 }) as any;
}
